import React from "react";

interface PageWrapperProps {
  children: React.ReactNode;
  children2?: React.ReactNode;
  additionalClassName?: string;
  wrapperClassName?: string;
}

export const PageWrapper = ({
  children,
  children2,
  additionalClassName,
  wrapperClassName,
}: PageWrapperProps) => {
  return (
    <div className={`flex flex-row-reverse h-screen bg-white ${wrapperClassName ?? ""}`}>
      <div className={`flex-grow flex flex-col ${additionalClassName ?? ""}`}>{children}</div>
      {children2}
    </div>
  );
};
